// // itemsWithUomLookup.logic.ts
// import type { APIResponse } from '@store/Shared/shared';
// import type {
//   ItemsWithUomBody,
//   ItemsWithUomQueryParams,
//   ItemWithUomRow,
//   PagedResponse
// } from './itemsWithUomLookup.api';
// import { fetchItemsWithUomLookup } from './itemsWithUomLookup.api';

// // ✅ نخلي body مرن (يدعم barcodeEqual وغيرها)
// export type ItemsWithUomBodyAny = ItemsWithUomBody & Record<string, any>;

// export type LookupOptions = {
//   signal?: AbortSignal;

//   // cache
//   cache?: boolean; // default true
//   cacheTtlMs?: number; // default 10 minutes
//   cacheKey?: string; // override stable key

//   // dedupe same request while in-flight
//   dedupeInFlight?: boolean; // default true
// };

// const DEFAULT_TTL = 10 * 60 * 1000;

// type Resp = APIResponse<PagedResponse<ItemWithUomRow>>;
// type CacheEntry = { ts: number; value: Resp };

// const cache = new Map<string, CacheEntry>();
// const inflight = new Map<string, Promise<Resp>>();

// export const clearItemsWithUomLookupCache = () => {
//   cache.clear();
//   inflight.clear();
// };

// // ==============================
// // Normalize + Stable Key
// // ==============================
// export const normalizeItemsWithUomParams = (p: ItemsWithUomQueryParams): ItemsWithUomQueryParams => {
//   if (!p?.InventoryId) {
//     // عند عدم وجود مخزن: اطفي WithLots لتجنب أي endpoint يعتمد على المخزن
//     return { ...p, InventoryId: undefined, WithLots: false };
//   }
//   return p;
// };

// const safeSortArray = (arr: any[]) => [...arr].sort((a, b) => String(a).localeCompare(String(b)));

// export const stableItemsWithUomKey = (params: ItemsWithUomQueryParams, body: ItemsWithUomBodyAny) => {
//   const p = normalizeItemsWithUomParams(params);

//   // itemIds ترتيبها يؤثر على key، نخليها ثابتة
//   const itemIds = Array.isArray(body?.itemIds) ? safeSortArray(body.itemIds) : null;

//   const keyObj = {
//     p: {
//       PriceListId: p.PriceListId ?? null,
//       Scope: p.Scope ?? null,
//       InventoryId: p.InventoryId ?? null,
//       WithParent: p.WithParent ?? null,
//       WithImage: p.WithImage ?? null,
//       WithLots: p.WithLots ?? null,
//       OnlyEnabled: p.OnlyEnabled ?? null,
//       WithLastPrice: p.WithLastPrice ?? null
//     },
//     b: {
//       pageIndex: body.pageIndex ?? null,
//       pageSize: body.pageSize ?? null,

//       itemCode: body.itemCode ?? null,
//       name: body.name ?? null,
//       barcode: body.barcode ?? null,

//       // ✅ دعم barcodeEqual حتى لو ما هو بالـ type الأصلي
//       barcodeEqual: (body as any).barcodeEqual ?? null,

//       categoryId: body.categoryId ?? null,
//       unitOfMeasure: body.unitOfMeasure ?? null,
//       brandId: body.brandId ?? null,

//       itemType: body.itemType ?? null,

//       purchasingEnabledFlag: body.purchasingEnabledFlag ?? null,
//       customerOrderEnabledFlag: body.customerOrderEnabledFlag ?? null,

//       itemIds
//     }
//   };

//   return JSON.stringify(keyObj);
// };

// // ==============================
// // Core lookup (params + body) with cache + inflight dedupe
// // ==============================
// export async function lookupItemsWithUom(
//   params: ItemsWithUomQueryParams,
//   body: ItemsWithUomBodyAny,
//   opts: LookupOptions = {}
// ): Promise<Resp> {
//   const p = normalizeItemsWithUomParams(params);

//   const cacheEnabled = opts.cache !== false;
//   const ttl = opts.cacheTtlMs ?? DEFAULT_TTL;
//   const dedupe = opts.dedupeInFlight !== false;

//   const key = opts.cacheKey ?? stableItemsWithUomKey(p, body);
//   const now = Date.now();

//   if (cacheEnabled) {
//     const hit = cache.get(key);
//     if (hit && now - hit.ts < ttl) return hit.value;
//   }

//   if (dedupe) {
//     const inF = inflight.get(key);
//     if (inF) return inF;
//   }

//   const promise = (async () => {
//     const res = await fetchItemsWithUomLookup(p, body as ItemsWithUomBody, opts.signal);
//     if (cacheEnabled) cache.set(key, { ts: Date.now(), value: res });
//     return res;
//   })().finally(() => {
//     inflight.delete(key);
//   });

//   if (dedupe) inflight.set(key, promise);

//   return promise;
// }

// export async function lookupItemsWithUomRows(
//   params: ItemsWithUomQueryParams,
//   body: ItemsWithUomBodyAny,
//   opts: LookupOptions = {}
// ): Promise<ItemWithUomRow[]> {
//   const resp = await lookupItemsWithUom(params, body, opts);
//   return Array.isArray(resp?.data?.data) ? resp.data.data : [];
// }

// // ==============================
// // Helpers: itemIds preload (chunking)
// // ==============================
// const chunk = <T>(arr: T[], size: number) => {
//   const out: T[][] = [];
//   for (let i = 0; i < arr.length; i += size) out.push(arr.slice(i, i + size));
//   return out;
// };

// export type LookupByItemIdsArgs = {
//   params: ItemsWithUomQueryParams;
//   itemType: string;

//   itemIds: string[];
//   pageSize?: number; // default 3000
//   pageIndex?: number; // default 1
//   chunkSize?: number; // default 200

//   bodyExtra?: Record<string, any>;
//   opts?: LookupOptions;
// };

// export async function lookupItemsWithUomRowsByItemIds(args: LookupByItemIdsArgs): Promise<ItemWithUomRow[]> {
//   const {
//     params,
//     itemType,
//     itemIds,
//     pageSize = 3000,
//     pageIndex = 1,
//     chunkSize = 200,
//     bodyExtra = {},
//     opts = {}
//   } = args;
// // debugger
//   const ids = Array.from(new Set((itemIds || []).filter(Boolean).map(String)));
//   if (ids.length === 0) return [];

//   // لو كانت قائمة كبيرة جداً، خلي الكاش اختياري لتقليل استهلاك الذاكرة
//   const autoCache = ids.length <= 300;
//   const effectiveOpts: LookupOptions = { cache: autoCache, ...opts };

//   const rows: ItemWithUomRow[] = [];
//   for (const part of chunk(ids, chunkSize)) {
//     const list = await lookupItemsWithUomRows(
//       params,
//       {
//         pageIndex,
//         pageSize,
//         itemType,
//         itemIds: part,
//         ...bodyExtra
//       },
//       effectiveOpts
//     );
//     rows.push(...list);
//   }
//   return rows;
// }

// // ==============================
// // Helpers: barcode
// // ==============================
// const norm = (s: any) => String(s ?? '').trim();

// export function pickBestRowForBarcode(rows: ItemWithUomRow[], scannedBarcode: string) {
//   if (!Array.isArray(rows) || rows.length === 0) return null;

//   const b = norm(scannedBarcode);

//   // 1) Exact match على barcode
//   const exact = rows.find(r => norm((r as any)?.barcode) === b);
//   if (exact) return exact;

//   // 2) احتياط لأسماء حقول مختلفة
//   const exact2 = rows.find(r => norm((r as any)?.barCode) === b || norm((r as any)?.barcodeValue) === b);
//   if (exact2) return exact2;

//   // 3) fallback primary uom
//   return (rows as any).find((r: any) => r?.isPrimaryUOM) || rows[0];
// }

// export type LookupByBarcodeArgs = {
//   params: ItemsWithUomQueryParams;
//   itemType: string;
//   barcode: string;

//   pageSize?: number; // default 20
//   pageIndex?: number; // default 1

//   // by default use barcodeEqual (exact)
//   barcodeField?: 'barcodeEqual' | 'barcode';

//   bodyExtra?: Record<string, any>;
//   opts?: LookupOptions;
// };

// export async function lookupBestRowByBarcode(args: LookupByBarcodeArgs): Promise<ItemWithUomRow | null> {
//   const {
//     params,
//     itemType,
//     barcode,
//     pageSize = 20,
//     pageIndex = 1,
//     barcodeField = 'barcodeEqual',
//     bodyExtra = {},
//     opts = {}
//   } = args;

//   const term = norm(barcode);
//   if (!term) return null;

//   const rows = await lookupItemsWithUomRows(
//     params,
//     {
//       pageIndex,
//       pageSize,
//       itemType,
//       ...(barcodeField === 'barcodeEqual' ? { barcodeEqual: term } : { barcode: term }),
//       ...bodyExtra
//     },
//     { cache: false, ...opts } // غالباً الباركود ما نبيه cache
//   );

//   return pickBestRowForBarcode(rows, term);
// }

// // ==============================
// // Utilities: Map helpers (itemId|uom)
// // ==============================
// export const makeDetailsKey = (itemId: any, uom: any) => `${String(itemId)}|${String(uom)}`;

// export function toDetailsMap(rows: ItemWithUomRow[]) {
//   const m = new Map<string, ItemWithUomRow>();
//   for (const r of rows || []) {
//     if (!r?.itemId || !r?.unitOfMeasure) continue;
//     m.set(makeDetailsKey(r.itemId, r.unitOfMeasure), r);
//   }
//   return m;
// }

// export function mergeIntoDetailsMap(target: Map<string, ItemWithUomRow>, rows: ItemWithUomRow[]) {
//   const out = new Map(target);
//   for (const r of rows || []) {
//     if (!r?.itemId || !r?.unitOfMeasure) continue;
//     out.set(makeDetailsKey(r.itemId, r.unitOfMeasure), r);
//   }
//   return out;
// }



// itemsWithUomLookup.logic.ts
import type { APIResponse } from '@store/Shared/shared';
import type {
  ItemsWithUomBody,
  ItemsWithUomQueryParams,
  ItemWithUomRow,
  PagedResponse
} from './itemsWithUomLookup.api';
import { fetchItemsWithUomLookup } from './itemsWithUomLookup.api';

// ✅ نخلي body مرن (يدعم barcodeEqual وغيرها)
export type ItemsWithUomBodyAny = ItemsWithUomBody & Record<string, any>;

export type LookupOptions = {
  signal?: AbortSignal;

  // cache
  cache?: boolean; // default true
  cacheTtlMs?: number; // default 10 minutes
  cacheKey?: string; // override stable key

  // dedupe same request while in-flight
  dedupeInFlight?: boolean; // default true
};

const DEFAULT_TTL = 10 * 60 * 1000;

type Resp = APIResponse<PagedResponse<ItemWithUomRow>>;
type CacheEntry = { ts: number; value: Resp };

const cache = new Map<string, CacheEntry>();
const inflight = new Map<string, Promise<Resp>>();

export const clearItemsWithUomLookupCache = () => {
  cache.clear();
  inflight.clear();
};

// ==============================
// Normalize + Stable Key
// ==============================
export const normalizeItemsWithUomParams = (p: ItemsWithUomQueryParams): ItemsWithUomQueryParams => {
  if (!p?.InventoryId) {
    // عند عدم وجود مخزن: اطفي WithLots لتجنب أي endpoint يعتمد على المخزن
    return { ...p, InventoryId: undefined, WithLots: false };
  }
  return p;
};

const safeSortArray = (arr: any[]) => [...arr].sort((a, b) => String(a).localeCompare(String(b)));

export const stableItemsWithUomKey = (params: ItemsWithUomQueryParams, body: ItemsWithUomBodyAny) => {
  const p = normalizeItemsWithUomParams(params);

  // itemIds ترتيبها يؤثر على key، نخليها ثابتة
  const itemIds = Array.isArray(body?.itemIds) ? safeSortArray(body.itemIds) : null;

  const keyObj = {
    p: {
      PriceListId: p.PriceListId ?? null,
      Scope: p.Scope ?? null,
      InventoryId: p.InventoryId ?? null,
      WithParent: p.WithParent ?? null,
      WithImage: p.WithImage ?? null,
      WithLots: p.WithLots ?? null,
      OnlyEnabled: p.OnlyEnabled ?? null,
      WithLastPrice: p.WithLastPrice ?? null
    },
    b: {
      pageIndex: body.pageIndex ?? null,
      pageSize: body.pageSize ?? null,

      itemCode: body.itemCode ?? null,
      name: body.name ?? null,
      barcode: body.barcode ?? null,

      // ✅ دعم barcodeEqual حتى لو ما هو بالـ type الأصلي
      barcodeEqual: (body as any).barcodeEqual ?? null,

      categoryId: body.categoryId ?? null,
      unitOfMeasure: body.unitOfMeasure ?? null,
      brandId: body.brandId ?? null,

      itemType: body.itemType ?? null,

      purchasingEnabledFlag: body.purchasingEnabledFlag ?? null,
      customerOrderEnabledFlag: body.customerOrderEnabledFlag ?? null,

      itemIds
    }
  };

  return JSON.stringify(keyObj);
};

// ==============================
// Core lookup (params + body) with cache + inflight dedupe
// ==============================
export async function lookupItemsWithUom(
  params: ItemsWithUomQueryParams,
  body: ItemsWithUomBodyAny,
  opts: LookupOptions = {}
): Promise<Resp> {
  const p = normalizeItemsWithUomParams(params);

  const cacheEnabled = opts.cache !== false;
  const ttl = opts.cacheTtlMs ?? DEFAULT_TTL;
  const dedupe = opts.dedupeInFlight !== false;

  const key = opts.cacheKey ?? stableItemsWithUomKey(p, body);
  const now = Date.now();

  if (cacheEnabled) {
    const hit = cache.get(key);
    if (hit && now - hit.ts < ttl) return hit.value;
  }

  if (dedupe) {
    const inF = inflight.get(key);
    if (inF) return inF;
  }

  const promise = (async () => {
    const res = await fetchItemsWithUomLookup(p, body as ItemsWithUomBody, opts.signal);
    if (cacheEnabled) cache.set(key, { ts: Date.now(), value: res });
    return res;
  })().finally(() => {
    inflight.delete(key);
  });

  if (dedupe) inflight.set(key, promise);

  return promise;
}

export async function lookupItemsWithUomRows(
  params: ItemsWithUomQueryParams,
  body: ItemsWithUomBodyAny,
  opts: LookupOptions = {}
): Promise<ItemWithUomRow[]> {
  const resp = await lookupItemsWithUom(params, body, opts);
  return Array.isArray(resp?.data?.data) ? resp.data.data : [];
}

// ==============================
// Helpers: itemIds preload (chunking)
// ==============================
const chunk = <T>(arr: T[], size: number) => {
  const out: T[][] = [];
  for (let i = 0; i < arr.length; i += size) out.push(arr.slice(i, i + size));
  return out;
};

export type LookupByItemIdsArgs = {
  params: ItemsWithUomQueryParams;
  itemType: string;

  itemIds: string[];
  pageSize?: number; // default 3000
  pageIndex?: number; // default 1
  chunkSize?: number; // default 200

  bodyExtra?: Record<string, any>;
  opts?: LookupOptions;
};

export async function lookupItemsWithUomRowsByItemIds(args: LookupByItemIdsArgs): Promise<ItemWithUomRow[]> {
  const {
    params,
    itemType,
    itemIds,
    pageSize = 3000,
    pageIndex = 1,
    chunkSize = 200,
    bodyExtra = {},
    opts = {}
  } = args;

  const ids = Array.from(new Set((itemIds || []).filter(Boolean).map(String)));
  if (ids.length === 0) return [];

  // لو كانت قائمة كبيرة جداً، خلي الكاش اختياري لتقليل استهلاك الذاكرة
  const autoCache = ids.length <= 300;
  const effectiveOpts: LookupOptions = { cache: autoCache, ...opts };

  const rows: ItemWithUomRow[] = [];
  for (const part of chunk(ids, chunkSize)) {
    const list = await lookupItemsWithUomRows(
      params,
      {
        pageIndex,
        pageSize,
        itemType,
        itemIds: part,
        ...bodyExtra
      },
      effectiveOpts
    );
    rows.push(...list);
  }

  return rows;
}

// ==============================
// Helpers: barcode (robust + prevent wrong UOM fallback)
// ==============================

/** Normalize barcode coming from scanner / API */
const normBarcode = (v: any) => {
  let s = String(v ?? '').trim();

  // بعض أجهزة المسح تضيف prefix مثل ]C1
  s = s.replace(/^\]C1/i, '');

  // شيل المسافات ومحارف التحكم
  s = s.replace(/\s+/g, '').replace(/[\r\n\t]/g, '');

  // تحويل أرقام عربية إلى إنجليزية (احتياط)
  s = s.replace(/[٠-٩]/g, d => '0123456789'['٠١٢٣٤٥٦٧٨٩'.indexOf(d)]);

  return s;
};

const barcodeCandidates = (row: any): string[] => {
  // أسماء حقول محتملة حسب backend / mapping
  const fields = [
    'barcode',
    'barCode',
    'Barcode',
    'barcodeValue',
    'BarcodeValue',
    'uomBarcode',
    'uomBarCode',
    'UomBarcode'
  ];

  const out: string[] = [];

  for (const f of fields) {
    const v = row?.[f];
    if (!v) continue;

    if (Array.isArray(v)) {
      for (const x of v) out.push(normBarcode(x));
    } else {
      const s = String(v);

      // لو كانت محفوظة كسلسلة مفصولة بفواصل
      s.split(',').forEach(x => out.push(normBarcode(x)));
    }
  }

  return out.filter(Boolean);
};

/**
 * ✅ هدفها: اختيار الصف الذي يطابق الباركود الممسوح فعلاً
 * - إذا لم نجد تطابق حقيقي => لا نرجع primary/first (لأنه يسبب اختيار UOM خاطئ)
 * - استثناء آمن: إذا رجع صف واحد فقط، نرجعه.
 */
export function pickBestRowForBarcode(rows: ItemWithUomRow[], scannedBarcode: string) {
  if (!Array.isArray(rows) || rows.length === 0) return null;

  // ✅ إذا رجع صف واحد فقط، غالباً الـ API فلتر فعلاً
  if (rows.length === 1) return rows[0];

  const b = normBarcode(scannedBarcode);

  // 1) Exact match على أي حقل باركود محتمل
  const exact = rows.find(r => barcodeCandidates(r).includes(b));
  if (exact) return exact;

  // 2) (اختياري) match بعد حذف leading zeros
  const bNoZeros = b.replace(/^0+/, '');
  if (bNoZeros) {
    const exact2 = rows.find(r => barcodeCandidates(r).some(x => x.replace(/^0+/, '') === bNoZeros));
    if (exact2) return exact2;
  }

  // ❗ لا fallback هنا لتجنب اختيار وحدة مختلفة
  return null;
}

export type LookupByBarcodeArgs = {
  params: ItemsWithUomQueryParams;
  itemType: string;
  barcode: string;

  pageSize?: number; // default 200
  pageIndex?: number; // default 1

  // by default use barcodeEqual (exact)
  barcodeField?: 'barcodeEqual' | 'barcode';

  bodyExtra?: Record<string, any>;
  opts?: LookupOptions;
};

const norm = (s: any) => String(s ?? '').trim();

export async function lookupBestRowByBarcode(args: LookupByBarcodeArgs): Promise<ItemWithUomRow | null> {
  const {
    params,
    itemType,
    barcode,
    pageSize = 200, // ✅ أكبر من السابق لتفادي paging لو الـ API يرجع أكثر من UOM
    pageIndex = 1,
    barcodeField = 'barcodeEqual',
    bodyExtra = {},
    opts = {}
  } = args;

  const term = norm(barcode);
  if (!term) return null;

  const rows = await lookupItemsWithUomRows(
    params,
    {
      pageIndex,
      pageSize,
      itemType,
      ...(barcodeField === 'barcodeEqual' ? { barcodeEqual: term } : { barcode: term }),
      ...bodyExtra
    },
    { cache: false, ...opts } // غالباً الباركود ما نبيه cache
  );

  // ✅ يرجع null إذا ما قدر يحدد UOM مطابق فعلاً بدل ما يختار primary خطأ
  return pickBestRowForBarcode(rows, term);
}

// ==============================
// Utilities: Map helpers (itemId|uom)
// ==============================
export const makeDetailsKey = (itemId: any, uom: any) => `${String(itemId)}|${String(uom)}`;

export function toDetailsMap(rows: ItemWithUomRow[]) {
  const m = new Map<string, ItemWithUomRow>();
  for (const r of rows || []) {
    if (!r?.itemId || !r?.unitOfMeasure) continue;
    m.set(makeDetailsKey(r.itemId, r.unitOfMeasure), r);
  }
  return m;
}

export function mergeIntoDetailsMap(target: Map<string, ItemWithUomRow>, rows: ItemWithUomRow[]) {
  const out = new Map(target);
  for (const r of rows || []) {
    if (!r?.itemId || !r?.unitOfMeasure) continue;
    out.set(makeDetailsKey(r.itemId, r.unitOfMeasure), r);
  }
  return out;
}
